import { FormItemTypes } from '@bimser/core';
import Control from './base/Control';

export class FormItemManagerClass {
	constructor() {}

	getFormItemInstance(type: string, isNativePlus = false): Control {
		if (type === FormItemTypes.EControlTypes.AutoComplete) {
			type = FormItemTypes.EControlTypes.ComboBox;
		}

		if (!isNativePlus && type === FormItemTypes.EControlTypes.DataGrid) {
			type = FormItemTypes.EControlTypes.DataGrid2;
		}

		const controlFile = require(`./components/${type.toString()}/index.js`);
		if (controlFile && controlFile.default) {
			const control = controlFile.default;
			return new control();
		}
		throw 'Control type not found.';
	}
}

const FormItemManager = new FormItemManagerClass();
export default FormItemManager;
